import { ContenedorPageTemplate } from "../../../components/templates/ContenedorPageTemplate"
import { TITULO_MODALIDAD_LIST } from "../../../utils/constantes"

export const ModalidadPage = () => {
  return <ContenedorPageTemplate titulo={TITULO_MODALIDAD_LIST}>ModalidadPage</ContenedorPageTemplate>
}